var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.5 12.5"}},[_c('g',{attrs:{"id":"レイヤー_2","data-name":"レイヤー 2"}},[_c('path',{attrs:{"d":"M14.5,9.5H3V0H14.5ZM4.5,8H13V1.5H4.5Z"}}),_c('polygon',{attrs:{"points":"10.75 12.5 0 12.5 0 3.75 1.5 3.75 1.5 11 10.75 11 10.75 12.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }